// extracted by mini-css-extract-plugin
var _1 = "DocFlowSendingResultTableRow-moduleDocFlowSendingResultTableRow__f6EMs TableComponent-modulerow__xPAo4";
export { _1 as "DocFlowSendingResultTableRow" }
